import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeviewAreaSystemComponent } from './treeview-area-system.component';
import { DxDropDownBoxModule,DxButtonModule, DxCheckBoxModule, DxDropDownButtonModule, DxNumberBoxModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxSwitchModule, DxTextAreaModule, DxTextBoxModule, DxTreeViewModule, DxTagBoxModule, DxDataGridModule } from 'devextreme-angular';
import { MdbGlobalModule } from '../mdb-global.module';
import { SystemControllerModule } from 'src/app/pages/estimation/system-controller/system-controller.module';
import { EditSystemMultipleModule } from '../EditSystemMultiple/EditSystemMultiple.module';
import { AIestimateModule } from 'src/app/pages/estimation/ai-estimate/ai-estimate.module';
import { ImportLibraryDinamicModule } from 'src/app/pages/estimation/import-from-library/import-from-library.module';



@NgModule({
  declarations: [TreeviewAreaSystemComponent,
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxTreeViewModule,
    DxButtonModule,
    DxDropDownButtonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxTextAreaModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxDropDownBoxModule,
    SystemControllerModule,
    DxTagBoxModule,
    DxDataGridModule,
    EditSystemMultipleModule,
    AIestimateModule,
    ImportLibraryDinamicModule
  ],
  exports: [TreeviewAreaSystemComponent,
  ]
})
export class TreeviewAreaSystemModule { }
